import { gql } from '@apollo/client'

export const SET_PAYMENT_METHOD_ON_CART = gql`
  mutation SetPaymentMethodOnCart(
    $cartId: String!
    $paymentMethod: PaymentMethodInput!
    $payuMethod: String
    $payuMethodType: String
  ) {
    cartId @client @export(as: "cartId")

    setPaymentMethodOnCart(
      input: {
        cart_id: $cartId
        payment_method: $paymentMethod
        payu_method: $payuMethod
        payu_method_type: $payuMethodType
      }
    ) {
      cart {
        items {
          id
        }
      }
    }
  }
`
